import React, { memo } from "react";
import { resolveVoucherPrintHeader } from "app/common/LocalFunction";

/** Tiêu đề org / pháp nhân trên phiếu thu */
export const VoucherPrintOrgHeading = memo(
  ({ department, withDepartmentName = false, as = "h4", style }) => {
    const header = resolveVoucherPrintHeader(department);
    const Tag = as;
    const title =
      withDepartmentName && !header.useLegalEntity && header.departmentName
        ? `${header.headingTitle} - ${header.departmentName}`
        : header.headingTitle;

    return (
      <div className="heading">
        <Tag style={style}>{title}</Tag>
        {header.useLegalEntity && header.taxCode ? (
          <div className="address-print" style={{ fontWeight: 600 }}>
            MST: {header.taxCode}
          </div>
        ) : null}
      </div>
    );
  }
);

/** Địa chỉ + SĐT — theo cơ sở (mode cũ) hoặc theo pháp nhân (mode legal_entity) */
export const VoucherPrintOrgAddress = memo(
  ({
    department,
    phonePrefix = "",
    addressClassName = "address-print",
    addressOverride,
    phoneOverride,
    style,
  }) => {
    const header = resolveVoucherPrintHeader(department);
    if (!header.showAddress) return null;

    const address =
      addressOverride !== undefined ? addressOverride : header.address;
    const phone = phoneOverride !== undefined ? phoneOverride : header.phone;

    if (!address && !phone) return null;

    const addressLabel = header.useLegalEntity ? "Địa chỉ: " : "";
    const phoneLabel = header.useLegalEntity
      ? "Điện thoại: "
      : phonePrefix || "";

    return (
      <>
        {address ? (
          <div className={addressClassName} style={style}>
            {addressLabel}
            {address}
          </div>
        ) : null}
        {phone || phoneLabel ? (
          <div className={addressClassName} style={style}>
            {phoneLabel}
            {phone}
          </div>
        ) : null}
      </>
    );
  }
);

/** Tên cơ sở cuối phiếu — ẩn khi chế độ pháp nhân */
export const VoucherPrintDepartmentFooter = memo(
  ({ department, style, className }) => {
    const header = resolveVoucherPrintHeader(department);
    if (!header.showDepartmentFooter || !header.departmentName) return null;

    return (
      <h3 style={style} className={className}>
        {header.departmentName}
      </h3>
    );
  }
);
